import { queryOptions } from '@tanstack/react-query'
import getStaffMe from '../api/get-staff-me'
import Staff from '../model/staff'

export const STAFF_ME_QUERY_KEY = ['staff-me'] as const

export type StaffMeQueryData = Staff

export const staffMeQueryOptions = queryOptions({
  queryKey: STAFF_ME_QUERY_KEY,
  queryFn: getStaffMe,
  staleTime: Infinity,
})
